import Vue from "vue";
import Router from "vue-router";
import constantes from "./constantes";

import AppHeader from "./cuerpo/Header";
import AppFooter from "./cuerpo/Footer";
import WizardNavs from "./componentes/wizard-navs";
import MenuUser from "./componentes/menu-usuario";
import banners from "./componentes/banners";

import Index from "./vistas/Paso1/Home";
import paso2 from "./vistas/Paso2/main-paso2";
import paso3 from "./vistas/Paso3/resumen";
import paso4 from "./vistas/Paso4/formulario";
import paso5 from "./vistas/Paso5/gracias";

import formulario from "./vistas/Paso4/formulario-generico";
import generico from "./vistas/Formulario/generico";
// import seltos from "./vistas/Landing/seltos";
//import pago from "./vistas/Paso4/formulario-tarjeta";

import cotizaciones from "./vistas/venta-online/cotizaciones";
import compras from "./vistas/venta-online/compras";
import credito from "./vistas/venta-online/credito";
import datosPersonales from "./vistas/venta-online/datosPersonales";
import detalleCompra from "./vistas/venta-online/compra/detalleCompra";
import contado from "./vistas/venta-online/compra/pagos/contado";
import licitudFondos from "./vistas/venta-online/compra/contado/licitudFondos";
import calculoCuota from "./vistas/venta-online/compra/credito/cuota";
import cambioContrasena from "./vistas/venta-online/cambioContrasena";

import {page} from 'vue-analytics';
import VueGtm from 'vue-gtm';
import solicitudCredito from "./vistas/venta-online/compra/credito/solicitudCredito";

import auth from './middleware/auth';

Vue.use(Router);

const nombes = constantes.Constantes.pasos;

const router = new Router({
    linkExactActiveClass: "active",
    mode: "history",
    routes: [
        {
            path: "/",
            components: {
                header: AppHeader,
                default: Index,
                banner: banners,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "p1",
        },
        {
            path: `/usuario`,
            redirect: {name: 'cotizaciones'}
        },
        {
            path: `/usuario/cotizaciones`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: cotizaciones,
            },
            name: "cotizaciones",
            meta: {title: constantes.Constantes.menu[1].label,middleware: auth},
        },
        {
            path: `/usuario/perfil`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: datosPersonales,
            },
            name: "datosPersonales",
            meta: {title: constantes.Constantes.menu[0].label,middleware: auth},
        },
        {
            path: `/usuario/perfil/contraseña`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: cambioContrasena,
            },
            name: "datosPersonales.contraseña",
            meta: {title: constantes.Constantes.menu[0].label,middleware: auth},
        },
        {
            path: `/usuario/compras`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: compras,
            },
            name: "compras",
            meta: {title: constantes.Constantes.menu[2].label,middleware: auth},
        },
        {
            path: `/usuario/compras/detalle`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: detalleCompra,
            },
            name: "compras.detalle",
            meta: {title: constantes.Constantes.menu[2].label + ' Detalle',middleware: auth},
        },
        {
            path: `/usuario/pagos`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: contado,
            },
            name: "compras.contado",
            meta: {title:'Pagos',middleware: auth},
        },
        {
            path: `/usuario/solicitudes/calculo`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: calculoCuota,
            },
            name: "compras.credito",
            meta: {title: constantes.Constantes.menu[2].label + ' Crédito',middleware: auth},
        },
        {
            path: `/usuario/solicitudes/credito/solicitud`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: solicitudCredito,
            },
            name: "compras.credito.solicitud",
            meta: {title: constantes.Constantes.menu[2].label + ' Crédito',middleware: auth},
        },
        {
            path: `/usuario/compras/contado/licitud`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: licitudFondos,
            },
            name: "compras.contado.licitud",
            meta: {title: constantes.Constantes.menu[2].label + ' Licitud de Fondos',middleware: auth},
        },
        {
            path: `/usuario/solicitudes`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: credito,
            },
            name: "credito",
            meta: {title: constantes.Constantes.menu[3].label,middleware: auth},
        },
        {
            path: `/usuario/solicitudes/detalle`,
            components: {
                header: AppHeader,
                footer: AppFooter,
                wizard: MenuUser,
                default: detalleCompra,
            },
            name: "credito.detalle",
            meta: {title: constantes.Constantes.menu[3].label + ' Detalle',middleware: auth},
        },
        {
            path: `/cotiza/Chatbotweb`,
            components: {
                header: AppHeader,
                default: formulario,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "formulario-generico",
            meta: {title: nombes[3].titulo},
            props: {
                default: {
                    elijeP: false,
                    tipo: constantes.Constantes.enumeraciones.campana.chatbot,
                },
                header:{
                    botonHome:true,
                }
            }
        },
        {
            path: `/cotiza/Chatbotweb/:titulo/:id`,
            components: {
                header: AppHeader,
                default: formulario,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "formulario",
            props:
                {
                    default: {
                        elijeP: false
                    },
                    header:{
                        botonHome:true,
                    }
                },
            meta: {title: nombes[3].titulo},
        },
        {
            path: `/:titulo/:id`,
            components: {
                header: AppHeader,
                default: paso2,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "p2",
            meta: {title: nombes[1].titulo}
        },
        {
            path: `/:titulo/:id/${constantes.funciones.urlParse(nombes[2].titulo)}`,
            components: {
                header: AppHeader,
                default: paso3,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "p3",
            meta: {title: nombes[2].titulo}
        },
        {
            path: `/:titulo/:id/${constantes.funciones.urlParse(nombes[3].titulo)}`,
            components: {
                header: AppHeader,
                default: paso4,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "p4",
            meta: {title: nombes[3].titulo}
        },
        {
            path: `/gracias`,
            components: {
                header: AppHeader,
                default: paso5,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "gracias",
            props:{
                header:{
                    botonHome:true,
                }
            }
        },
        {
            path: "/campanacrm",
            components: {
                header: AppHeader,
                default: formulario,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "formulario-crm",
            meta: {title: nombes[3].titulo},
            props: {
                default: {
                    elijeP: false,
                    tipo: constantes.Constantes.enumeraciones.campana.crm,
                },
                header:{
                    botonHome:true,
                }
            }
        },
        {
            path: "/campana-post-venta",
            components: {
                header: AppHeader,
                default: generico,
                footer: AppFooter,
                wizard: WizardNavs,
            },
            name: "/formulario-post-venta",
            meta: {title: nombes[3].titulo},
            props: {
                default: {
                    elijeP: false,
                    tipo: constantes.Constantes.enumeraciones.campana.postVenta,
                    noIntegrar: true,
                    tieneP: true,
                    escribeV: true,
                },
                header:{
                    botonHome:true,
                }
            }
        },
        {
            path: "*",
            name: "404",
            redirect: {name: 'p1'}
        }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return {selector: to.hash};
        } else {
            return {x: 0, y: 0};
        }
    }
});
const DEFAULT_TITLE = process.env.VUE_APP_TITLE || "Kia Personaliza";

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}


router.afterEach((to,from,next) => {
    document.title = to.meta.title || DEFAULT_TITLE;
    page(location.origin + to.path);
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };
        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({ ...context, next: nextMiddleware });
    }
    return next;
});
Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TAG_KEY,
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: router,
});

export default router;
